export default "__VITE_ASSET__CGtRa1Se__"